module.exports = __webpack_public_path__ + "static/media/Mailing-Clergy-SALVATION.2bd2996b.pdf";